import React, { memo } from 'react'
import styled from 'styled-components'

const StyledItem = styled.div`
font-size: 14px;
font-weight: 300;
padding: 10px;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
color: ${props => props.color || '#3e4c57'};
border-top: ${props => props.bordered ? '1px solid rgba(201, 201, 201, 0.2)' : 'none'};
opacity: ${({ available = true }) => available ? '1' : '.5'};
pointer-events: ${({ available = true }) => available ? 'auto' : 'none'};
&:hover {
	cursor: pointer;
}
& .cashregister_length{
	display: inline-block;
	margin: 0px 5px;
	background-color: #CDCDCD;
	font-size: 12px;
	font-weight: 600;
	opacity: 0.75;
	color: white;
	width: ${({ isNumberBig }) => isNumberBig ? '20px' : '15.8px' };
	min-width: ${({ isNumberBig }) => isNumberBig ? '20px' : '15.8px' };
	line-height: 15.8px;
	border-radius: 50%;
	text-align: center;
}
`

const DropdownItem = (props) => {
	const { label, handleClick = () => {}, children, reason } = props
	let cashRegistersLength
	let isNumberBig
	if(props?.__typename === 'Shop' && props?.cashRegisters) {
		cashRegistersLength = `${props.cashRegisters.length}`
		isNumberBig = cashRegistersLength.length > 1
	}

	const isReasonShown = reason && reason !== ' ' && reason !== 'nan'

	return (
		<StyledItem 
			onClick={handleClick} 
			{...props} 
			isNumberBig={isNumberBig}
			className='dropdownItem'
		>
			{children || label}{cashRegistersLength && <span className='cashregister_length'>{cashRegistersLength}</span>} {isReasonShown && `(${reason})`}
		</StyledItem>
	)
}

const itemsPropsAreEqual = (prev, next) => {
	return prev.color === next.color
}

export default memo(DropdownItem, itemsPropsAreEqual)
